module.exports = __webpack_public_path__ + "img/buenos_aires_caballito.fa43d619.jpg";